import { formatInvoiceMoney } from '@/features/invoicing/format'
import { tokenManager } from '@/lib/tokenManager'

export async function downloadPayslipPdf(id: string, label: string): Promise<void> {
  const token = tokenManager.get()
  const res = await fetch(`/api/payroll/payslips/${id}/pdf`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!res.ok) throw new Error(`Failed to download payslip (${res.status})`)
  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `Payslip-${label}.pdf`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export function centsToDecimal(cents: string | number | bigint, currencyDecimals = 2): string {
  const value = typeof cents === 'bigint' ? cents : BigInt(cents)
  const negative = value < 0n
  const abs = negative ? -value : value
  const factor = 10n ** BigInt(currencyDecimals)
  const whole = abs / factor
  const remainder = abs % factor
  const fracStr = remainder.toString().padStart(currencyDecimals, '0')
  return (negative ? '-' : '') + whole.toString() + (currencyDecimals > 0 ? '.' + fracStr : '')
}

export function formatPayrollMoney(cents: string | number | bigint, currency = 'USD'): string {
  const amount = Number(centsToDecimal(cents))
  return formatInvoiceMoney(amount, currency)
}

export function formatHours(hours: string | number | null | undefined): string {
  if (hours == null || hours === '') return '-'
  const n = typeof hours === 'string' ? Number(hours) : hours
  if (!Number.isFinite(n)) return '-'
  return n.toFixed(2)
}
